import * as React from "react";
import { Authenticated } from "./Authenticated";
import UserContext from "./UserContext";
import { Form, FormControl, Button } from "react-bootstrap"
import { ApiHelper, ToastHelper } from "./helpers";

export const Forgot: React.FC = () => {
  const [email, setEmail] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const context = React.useContext(UserContext);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    switch (e.currentTarget.id) {
      case "email": setEmail(e.currentTarget.value); break;
    }
  }

  const submitReset = async (email: string) => {
    setIsSubmitting(true);
    const resp = await ApiHelper.postAnonymous<{ emailed: boolean }>("/users/forgot", { email: email });
    if (!resp.emailed) {
      ToastHelper.error("Email not found.");
    } else {
      ToastHelper.success("Password reset email sent");
    }
    setIsSubmitting(false);
  }

  const handleSubmit = (e: React.MouseEvent) => {
    if (email.length === 0) {
      ToastHelper.error("Please enter an email address.");
    } else {
      submitReset(email);
    }
  }

  const getLoginBox = () => {
    return (
      <div id="loginBox" >
        <h2>Reset Password:</h2>

        <Form.Group className="mb-3">
          <FormControl data-testid="forgot-email-input" type="text" aria-label="email" id="email" value={email} onChange={handleChange} placeholder="Email address" />
        </Form.Group>
        <Button data-testid="reset-password-button" type="submit" id="signInButton" size="lg" variant="primary" className="d-grid" disabled={isSubmitting} style={{ width: "100%" }} onClick={handleSubmit}>
          {(isSubmitting) ? "Please wait..." : "Reset Password"}
        </Button>

      </div>
    );
  }




  if (context.userName === "" || !ApiHelper.isAuthenticated) {
    return (<div className="smallCenterBlock">{getLoginBox()}</div>);
  } else {
    return <Authenticated />;
  }
};